$(document).ready(function () {

    (function () {

        let video = $('.js-video'),
            play = $('.js-play-btn'),
            header = $('.js-header');

        if (video.length) {

            play.click(function () {

                video.addClass('active');
                $(this).parents('.info-box').addClass('hide');
                header.addClass('hide');


            });

            video.find('.video-close').click(function () {

                let source = video.find('iframe').attr('src');
                video.removeClass('active');
                play.parents('.info-box').removeClass('hide');
                header.removeClass('hide');
                setTimeout(function () {
                    video.find('iframe').attr('src', source);
                }, 500);

            });

        }

    })();

});


// WEBPACK FOOTER //
// ./scripts/video.js